define('shared/client',["jquery"], function ($) {
	var Client = function Client(){}
	Client.prototype.isPublic = function() {
		return window.appData.client.is_public;
	}

	Client.prototype.isGoogleSync = function() {
		return window.appData.client.sync_strategy === "google";
	}

	Client.prototype.isMicrosoftSync = function () {
		return window.appData.client.sync_strategy === "microsoft";
	}

	Client.prototype.isCleverSync = function() {
		return window.appData.client.sync_strategy === "clever";
	}

	Client.prototype.isClassLinkSync = function() {
		return window.appData.client.sync_strategy === "classlink";
	}

	Client.prototype.isOnDemandSync = function() {
		return (window.appData.client.sync_strategy === "clever" || window.appData.client.sync_strategy === "classlink")
	}

	Client.prototype.showResourceKits = function() {
		return (window.appData.client.settings && window.appData.client.settings.dashboard && window.appData.client.settings.dashboard.show_resource_kits == "1");
	}

	Client.prototype.assetURL = function(path) {
		if(path[0] === '/') {
			return window.appData.client.cloudfront_url + path + "?release=" + window.appData.config.release_id;	
		}
		return window.appData.client.cloudfront_url + '/' + path + "?release=" + window.appData.config.release_id;
	}

	Client.prototype.cdnURL = function(path) {
		return this.assetURL(path);
	}

	Client.prototype.getAPIURL = function() {
		return window.appData.client.api_url;
	}

	Client.prototype.getPublicAPIURL = function() {
		return window.appData.client.api_url.replace(this.getName(),window.appData.client.public_client_name);
	}

	Client.prototype.getResourceAPIURL = function() {
		return window.appData.client.api_url.replace(this.getName(),window.appData.client.resource_client_name);
	}

	Client.prototype.getName = function() {
		return window.appData.client.name;
	}

	Client.prototype.getWebURL = function() {
		return window.appData.client.web_url;
	}

	return new Client();
});
